export enum typeApplyAll {
  applyPlant = "plant",
  applyShippingPoint = "shippingPoint"
}

export enum ConsignmentType {
  CUSTOMER = "Customer",
  SALE_GROUP = "Sale group"
}

export interface DataModalAddressProps {
  initAddress: string;
  id: string;
}

export interface DataApplyAllProps {
  title: string;
  placeholder: string;
  anchorEl: HTMLButtonElement | null;
  type: typeApplyAll | null;
  regex?: RegExp;
  maxLength?: number;
}
